import { Question, QuestionTypes } from '@playbooks/core/src/interfaces/ActionCard'

import { SignatureData } from './types'

export default function isSignatureQuestion(value: Question): value is Question<SignatureData> {
  return value.type === QuestionTypes.SIGNATURE
}
